import '@/globals';
import Complaint from "../components/Complaint";

const complaint = new Complaint();

complaint.init();

